"use client";
import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
import { pushEvent } from "@/lib/analytics/gtm";
import { analyticsEvents } from "@/lib/analytics/events";

function derivePageType(path: string): string {
  if (path === "/") return "home";
  if (path.startsWith("/sticker-pack/")) return "pack";
  if (path.startsWith("/hashtag/")) return "hashtag";
  if (path.startsWith("/search")) return "search";
  if (path === "/contact-us" || path === "/partnership-proposal") return "form";
  if (
    path.startsWith("/about") ||
    path.startsWith("/privacy-policy") ||
    path.startsWith("/cookie-policy") ||
    path.startsWith("/terms-of-use") ||
    path.startsWith("/dmca-policy") ||
    path.startsWith("/content-policy") ||
    path.startsWith("/licence") ||
    path.startsWith("/delete-account")
  )
    return "legal";
  if (path.startsWith("/s/")) return "deeplink";
  // /sticker/<id> and /@<name> redirect before a pageview can fire; the
  // profile they and /u/<id> lead to is the page that gets counted.
  if (path.startsWith("/u/")) return "creator";
  return "other";
}

export function PageviewTracker() {
  const pathname = usePathname();
  const lastFired = useRef<string | null>(null);

  useEffect(() => {
    if (!pathname || lastFired.current === pathname) return;
    lastFired.current = pathname;
    pushEvent(analyticsEvents.page_view, {
      path: pathname,
      title: document.title,
      referrer: document.referrer || undefined,
      page_type: derivePageType(pathname),
    });
  }, [pathname]);

  return null;
}
